export default __webpack_public_path__ + "static/media/affect-lab.6074d0c9.png";